import { Injectable } from '@angular/core';
import { AlertController, Platform } from 'ionic-angular';
import { Network } from '@ionic-native/network';


@Injectable()
export class NetworkProvider {

  public connectionStatus: any;


  public networkAlert = this.alertCtrl.create();
  public previousStatus: any;
  firstTime = false;

  constructor(public alertCtrl: AlertController, 
              public platform: Platform,
              public network: Network) {

    this.connectionStatus = "online";        
  }


  /**
   * Récupération du statut de connexion du téléphone
   */
  isConnected(){
    let platform = this.platform.is('core') || this.platform.is('mobileweb') ? false : true;
    if (!platform)
      return window.navigator.onLine;
    else
      return this.network.type !== 'none';
  }



  detectNetwork(){
    this.network.onConnect().subscribe(data => {    
      if (!this.firstTime && this.previousStatus == 0){
        this.networkAlert.dismiss();
      }
      
      this.previousStatus = 1;
    }, error => console.error(error));
   
    this.network.onDisconnect().subscribe(data => {
      if (this.previousStatus == 1 || this.previousStatus == null){
        this.checkNetwork();
      }

      this.previousStatus = 0;
    }, error => console.error(error));
  }

  checkNetwork(){
      this.networkAlert = this.alertCtrl.create({
        title: 'Network is Down',
        message: 'Please, make sure that you are connected to the network in order to proceed.',
        enableBackdropDismiss: false
      })

      this.networkAlert.present();
  }

}


// WEBPACK FOOTER //
// ./src/providers/network/network.provider.ts